
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {ProfileComponent} from "./profile.component";
import {MatIconModule} from "@angular/material/icon";
import {FlexLayoutModule} from "@angular/flex-layout";

@NgModule({
    declarations: [
        ProfileComponent
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        FlexLayoutModule,

    ],
    providers: [],
    bootstrap: [ProfileComponent]
})
export class ProfileModule { }
